/**
 * お問い合わせフルスクリーンモーダル
 * [data-contact-modal] 属性を持つ要素クリックで開く
 */
const contactModal = () => {
  const modal = document.getElementById('js-contact-modal');
  if (!modal) return;

  const triggers = document.querySelectorAll('[data-contact-modal]');
  const closeBtn = modal.querySelector('.m-cf7-modal__close');
  const headerCloseBtn = document.querySelector('.js-contact-modal-close');
  const openClass = 'is-open';
  const scrollLockClass = 'is-contact-modal-open';
  const headerClass = 'is-contact-modal-header';

  let lastTrigger = null;

  const isVisible = (el) => {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return (
      style.visibility !== 'hidden' &&
      style.display !== 'none' &&
      el.getBoundingClientRect().width > 0
    );
  };

  const getFocusableInModal = () => [
    ...modal.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select',
    ),
  ];

  // PC時はヘッダーの閉じるボタンをトラップ対象の先頭に追加
  const getAllFocusable = () => {
    const inModal = getFocusableInModal();
    if (headerCloseBtn && isVisible(headerCloseBtn)) {
      return [headerCloseBtn, ...inModal];
    }
    return inModal;
  };

  const open = (trigger) => {
    lastTrigger = trigger;
    modal.classList.add(openClass);
    document.documentElement.classList.add(scrollLockClass);
    document.documentElement.classList.add(headerClass);

    const focusable = getFocusableInModal();
    if (focusable.length) focusable[0].focus();

    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('focusin', handleFocusIn);
  };

  const close = () => {
    modal.classList.remove(openClass);
    document.documentElement.classList.remove(headerClass);
    document.removeEventListener('keydown', handleKeydown);
    document.removeEventListener('focusin', handleFocusIn);

    if (lastTrigger && isVisible(lastTrigger)) {
      lastTrigger.focus();
    }
    lastTrigger = null;

    const inner = modal.querySelector('.m-cf7-modal__inner');
    const onTransitionEnd = (event) => {
      if (event.propertyName !== 'opacity') return;
      inner.removeEventListener('transitionend', onTransitionEnd);
      document.documentElement.classList.remove(scrollLockClass);
    };
    inner.addEventListener('transitionend', onTransitionEnd);
  };

  const handleFocusIn = (event) => {
    if (modal.contains(event.target)) return;
    if (headerCloseBtn && event.target === headerCloseBtn) return;
    const focusable = getFocusableInModal();
    if (focusable.length) focusable[0].focus();
  };

  const handleKeydown = (event) => {
    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getAllFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      open(trigger);
    });
  });

  closeBtn?.addEventListener('click', close);
  headerCloseBtn?.addEventListener('click', close);
};

export { contactModal };
